import {Component, QueryList, ViewChildren} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {OperationCard} from "../../model/OperationCard";
import {KpiService} from "../../services/KpiService";
import {HomeKpi} from "../../model/HomeKpi";
import {LocupaChartsServiceProvider} from "../../providers/locupa-charts-service/locupa-charts-service";
import {MonthlyPlanningPage} from "../order-list/monthly-view";
import {FieldTeamActivityReportPage} from "../field-team-activity-report/field-team-activity-report";
import {QuotaPage} from "../quota/quota";
import {AuthService} from "../../services/AuthService";
import {OrderService} from "../../services/OrderService";
import {ActivityDate, ActivityWeek, DateService} from "../../services/DateService";
import {apiconfig} from "../../app/api.config";
import {SlotsPlanningProgressReportPage} from "../slots-planning-progress-report/slots-planning-progress-report";
import {QuotaBudgetPage} from "../quota/quota-budget";
import {Activity} from "../../model/Order";
import {StoreLocation} from "../../model/Store";
import {Operation} from "../../model/Operation";
import {PlanningMissionPurpose} from "../../model/OrderRequest";

/**
 * Generated class for the OperationDashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


export class HomePageActivity {
  activity: Activity;
  location: StoreLocation;
  operation: Operation;
  operationLogoUrl: string;
  hrStatus: string;
  cssStatus: string;

  plannedPurposes: PlanningMissionPurpose[];
  presence: boolean;
}

@IonicPage()
@Component({
  selector: 'page-operation-dashboard',
  templateUrl: 'operation-dashboard.html',
})
export class OperationDashboardPage {

  @ViewChildren('chart') kpiCharts: QueryList<any>;

  private uiloading: boolean;
  iconsURL: string = apiconfig.LOGA_ICONS;

  private currentWeek: ActivityWeek;
  private today: ActivityDate;

  private uiOpCard: OperationCard;
  private uiOperationName: string;
  private homeKpi: HomeKpi[];
  private uiActivities: HomePageActivity[] = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private locupaChartsServiceProvider: LocupaChartsServiceProvider, private kpiService: KpiService, public authService: AuthService, private dateService: DateService, private  orderService: OrderService) {
  }

  ionViewWillEnter() {
    this.uiloading = true;
    let operation: OperationCard = this.navParams.get('operationCard');
    this.uiOperationName = operation.name;
    this.uiOpCard = operation;


    this.currentWeek = this.dateService.getCurrentWeek();

    this.currentWeek.activityDates.forEach(d => {
      if (d.isToday()) {
        this.today = d;
      }
    });

  }

  ionViewDidEnter() {
    console.log('ionViewDidLoad OperationDashboardPage');
    this.kpiService.loadHomeKpiSheet(this.uiOpCard.id).then(homeKpi => {
      this.homeKpi = homeKpi;
      this.uiloading = false;


      this.kpiCharts.changes.subscribe(() => this.kpiCharts.toArray().forEach(
        (item) => {

          let opIdAndKpiType: string = item.nativeElement.id.split('|');
          if (opIdAndKpiType.length === 2) {

            let opId = opIdAndKpiType[0];
            let kpiId = opIdAndKpiType[1];

            this.homeKpi.forEach(hkpi => {
              if (hkpi.id == kpiId)
                this.locupaChartsServiceProvider.buildHomeKpiChart(hkpi, item);
            });
          }
        })
      );
    });

    this.orderService.loadOrderFromApi(this.currentWeek.getStartDate(), undefined, this.uiOpCard.id).then(orders => {
      if (orders != null) {
        orders.forEach(o => {
          if (o.activities != null) {
            o.activities.forEach(act => {
              if (act.day >= this.today.dateStamp && act.day <= this.today.dateStamp + 7) {
                let act2 = new HomePageActivity();
                act2.activity = act;
                act2.location = o.location;
                act2.operation = o.operation;

                act2.hrStatus = o.toHrStatus();
                act2.cssStatus = o.cssStatus();

                act2.plannedPurposes = o.plannedPurposes;

                //legacy behaviour with mono purpose
                if (o.planningPurpose && (act2.plannedPurposes == null || act2.plannedPurposes.length == 0)) {
                  let e = new PlanningMissionPurpose();
                  e.instructions = '';
                  e.purposeName = o.planningPurpose.name;
                  e.purposeId = o.planningPurpose.id;
                  act2.plannedPurposes.push(e);
                }

                act2.presence = o.presence;

                this.uiActivities.push(act2);
              }
            });
          }
        });
      }
    });


  }

  openDashboard(card: OperationCard) {
    let animaToken: string = this.authService.buildAnimaDashboardToken(card.id, card.rolDefinitionName);
    let target = "_system";
    window.open(card.urlDashboard + "&token=" + animaToken, target);
  }

  openMonthlyView(id: number, opName: string) {
    this.navCtrl.push(MonthlyPlanningPage, {operationId: id, operationName: opName});
  }

  openOrderReportView(card: OperationCard) {
    this.navCtrl.push(FieldTeamActivityReportPage, {'operationCard': card});
  }

  openQuotaView(card: OperationCard) {
    this.navCtrl.push(QuotaPage, {'operationCard': card});
  }

  openBudgetQuotaView(card: OperationCard) {
    this.navCtrl.push(QuotaBudgetPage, {'operationCard': card});
  }

  openContactView(card: OperationCard) {
    // not work with window.open (in dev ok, not when we release the apk)
    location.href = 'mailto:' + card.emailManager + '?subject=Contact';
  }

  openSlotPlanningProgressReportView(card: OperationCard) {
    this.navCtrl.push(SlotsPlanningProgressReportPage, {'operationCard': card});
  }


  computeStart(act: HomePageActivity) {
    if (act.activity.amStartTime != null) return act.activity.amStartTime;
    else return act.activity.pmStartTime;
  }

  toFormatMissionDuration(hpAct: HomePageActivity) {

    let act = hpAct.activity;

    let nbMinAm: number = 0;
    let nbMinPm: number = 0;
    if (act.amStartTime && act.amEndTime)
      nbMinAm += Math.abs(act.amEndTime.valueOf() - act.amStartTime.valueOf()) / (1000 * 60);

    if (act.pmStartTime && act.pmEndTime)
      nbMinPm += Math.abs(act.pmEndTime.valueOf() - act.pmStartTime.valueOf()) / (1000 * 60);
    let durationInMinutes = Math.abs(Number(nbMinAm) + Number(nbMinPm));

    let nbHours = Math.floor(durationInMinutes / 60);
    let nbMinutes = Math.floor(durationInMinutes % 60);

    if (nbMinutes && nbMinutes > 0) {
      return nbHours + "h" + nbMinutes;
    }

    return nbHours + "h";
  }
}



// WEBPACK FOOTER //
// ./src/pages/operation-dashboard/operation-dashboard.ts